// This svg is > 500kb in size contribution to the RN bundle
// Since we are currently not using quests, i'm disabling it to save on the bundle size
// If we are to bring this back, we should optimize the svg.
export const QuestPointsPicture = (_: { bonusPoints: number }) => null;
